'use strict';

var ProfileChartPanelDirective = function ProfileChartPanelDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/profile-chart-panel.html'),
    controller: 'ProfileChartPanelController',
    scope: {
      contextData: '=',
      metrics: '=',
      visible: '='
    }
  };
};
ProfileChartPanelDirective.$inject = [];
module.exports = ProfileChartPanelDirective;